define('cartware_checkout/components/advises/shipping',[
	"jquery",
	"cartware/components/_base",
	"cartware_checkout"
], function(
	$,
	Component,
	CartwareCheckout
) {
	var register;

	CartwareCheckout().retrieve("register", function(reg) {
		register = reg;
	});

	return Component.create({
		init: function() {
			Shipping.prototype.save = function() {
				if (checkout.loadWaiting!=false) return;

				var validator = new Validation(this.form);

				var params = Form.serialize(this.form);

				if (register && register.isActive()) {
					if (!register.validate()) return;

					params += '&' + Form.serialize(register.getForm());
				}

				if (validator.validate()) {
					checkout.setLoadWaiting('shipping');
					var request = new Ajax.Request(
						this.saveUrl,
						{
							method:'post',
							onComplete: this.onComplete,
							onSuccess: this.onSave,
							onFailure: checkout.ajaxFailure.bind(checkout),
							parameters: params
						}
					);
				}
			};

			Shipping.prototype.nextStep = function(transport) {
				var response = transport.responseJSON || transport.responseText.evalJSON(true) || {};

				if (response.blocks && ('register' in response.blocks)) {
					$('#customer-account-registration').replaceWith(response.blocks['register']);
				}

				if (response.error){
					if ((typeof response.message) == 'string') {
						alert(response.message);
					} else {
						if (window.shippingRegionUpdater) {
							shippingRegionUpdater.update();
						}
						alert(response.message.join("\n"));
					}

					return false;
				}

				//checkout.setStepResponse(response);
				checkout.gotoSection('billing', true);
			};

			Shipping.prototype.setSameAsBilling = function(flag) {

			};

			var _newAddress = Shipping.prototype.newAddress;
			Shipping.prototype.newAddress = function(flag) {
				_newAddress.apply(this, arguments);

				if ("accordion" in window) {
					window.accordion._layout();
				}
			}
		}
	});
});
